export const shell = "mx-auto max-w-[1180px] px-[22px] sm:px-8";

export const section = "py-[60px] sm:py-[95px]";

export const eyebrow = "mb-5 text-[10px] font-bold uppercase tracking-[2px] text-[#bdc6b2] sm:mb-[25px]";

export const h2 =
  "mb-6 font-display text-[34px] font-medium leading-[1.2] tracking-[-1.5px] sm:text-[36px] lg:text-[43px] lg:tracking-[-2px]";

export const body = "text-sm leading-[1.75] text-muted sm:text-[15px]";

export const button =
  "inline-flex items-center justify-between gap-7 rounded-lg bg-lime px-[21px] py-[17px] text-[13px] font-bold text-olive transition-[background-color,transform] duration-200 ease-out hover:-translate-y-0.5 hover:bg-lime-hover";

export const micro = "mt-[17px] text-[11px] leading-relaxed text-dim";
